

export const AlertMessage = ({type, text="삭제된 독서 활동입니다.", visible=false}) => {

  if (!visible) return null;
  return (
    <span className={`alertMessage fs-12
                      ${type}
                      ${text.length > 6 ? "spread" : "sm"}`}>
      <p className="text">{text}</p>
    </span>
  );

};